import React from 'react';
import { Alert, Typography } from '@mui/material';
import { formatTransactionAmount } from 'features/transaction-details/helpers';
import { RefundImpactNavigationButtons } from '../RefundImpactNavigationButtons';

interface AuthorizationRefundSaleOrderNoteProps {
	authorizationId: number;
	totalRefunded: number;
	coinCode: string;
	dealId: number;
	saleOrderId?: string | null;
	isFullyRefunded: boolean;
	onError?: (message: string) => void;
}

export const AuthorizationRefundSaleOrderNote = ({
	totalRefunded,
	coinCode,
	dealId,
	saleOrderId,
	isFullyRefunded,
	onError,
}: AuthorizationRefundSaleOrderNoteProps): JSX.Element => (
	<Alert severity="info" sx={{ mt: 1 }}>
		<Typography variant="body2" component="div">
			{isFullyRefunded ? (
				<>
					Esta autorización fue <strong>reembolsada al 100%</strong> ({formatTransactionAmount(totalRefunded, coinCode)}
					). Ese monto vuelve a quedar <strong>pendiente de autorizar</strong> en esta transacción.
				</>
			) : (
				<>
					Se registró un reembolso de {formatTransactionAmount(totalRefunded, coinCode)} en esta autorización. Ese monto
					vuelve a quedar pendiente de autorizar en esta transacción.
				</>
			)}{' '}
			El <strong>caso de venta {dealId}</strong> vuelve a tener <strong>saldo pendiente con el cliente</strong> por ese
			importe hasta que se registre una nueva autorización contra aerolínea.
		</Typography>
		<RefundImpactNavigationButtons dealId={dealId} saleOrderId={saleOrderId} onError={onError} />
	</Alert>
);
